import './category_type_switcher_component.scss'

import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['button']

  switch (event) {
    event.preventDefault()
    this.reset()
    event.target.classList.add('category_type_switcher-button--selected')
    this.targetController.switchCategoryType(event.target.dataset.categoryType)
  }

  reset () {
    this.buttonTargets.map((button) => {
      button.classList.remove('category_type_switcher-button--selected')
    })
  }

  get targetController () {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === this.targetControllerIdentifier
    })
  }

  get targetControllerIdentifier () {
    return this.data.get('targetControllerIdentifier')
  }
}
